var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 32,
    viewBox: "0 0 141 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9061 14.7692L0 0H126.199L141 14.7692L126.199 32H63.0994H0L10.9061 14.7692Z",
    fill: "#D3ECF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlue);
export default __webpack_public_path__ + "static/media/left-arrow-blue.c0a45161cd956adaf49287f86bac5d02.svg";
export { ForwardRef as ReactComponent };